/**
 * Front-end behavior for Custom HTML (scoped to block instances).
 */
import { striderEnhanceCustomHtmlBlocks } from './striderCustomHtmlScripts.js';

export class CustomHtmlFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		striderEnhanceCustomHtmlBlocks( this.root );
		this.root.querySelectorAll( '[data-block="custom-html"]' ).forEach( ( el ) => {
			el.classList.add( 'custom-html-enhanced' );
		} );
	}
}
